import React from "react";
import { AuthProvider } from "./contexts/authContext";

const Providers = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>;
};

export default Providers;
